import { Grid, Paper, Tooltip } from "@mui/material"
import React, { useContext, useEffect, useMemo } from "react"
import { NonEditableTextField } from "../../../../../../../../../../../components/inputs/text-input/NonEditableTextField"
import { BSInputContext } from "../../../../../../../../../../../core/context/beem-shot/BSInput/BSInputContext"
import { usageEnumLabels } from "../../../../../../../../../../../core/enum/usageEnum"
import { GroupLevel } from "../../../context/GroupLevel"
import { BSLevelFormContext } from "../../../context/BSLevelFormContext"

interface IProps {
  groupLevel: GroupLevel
  parkingPercentageSum: number
}

export function ZoneInfos({ groupLevel, parkingPercentageSum }: Readonly<IProps>): React.JSX.Element {
  const { bsInput } = useContext(BSInputContext)
  const { setFormFieldValue } = useContext(BSLevelFormContext)

  const zonePercentage = useMemo(() => groupLevel.levelList[0]?.zonePercentage, [groupLevel.levelList])

  useEffect(
    () => {
      setFormFieldValue("zonePercentage", 100 - parkingPercentageSum, groupLevel.id, groupLevel.levelList[0].superstructure)
    },
    //groupeLevel.id, groupLevel.levelList
    [setFormFieldValue, parkingPercentageSum]
  )

  return (
    <Paper elevation={0} sx={{ m: 1 }}>
      <Grid container alignItems="center" columnSpacing={1}>
        <Grid item container xs={11} columnSpacing={1} borderRadius={4} p={1} boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1)">
          <Grid item xs={8}>
            <NonEditableTextField label="Usage" value={bsInput && usageEnumLabels[bsInput?.usage]} />
          </Grid>
          <Grid item xs={4}>
            <Tooltip title="par rapport à la surface du groupe" arrow placement="right">
              <div>
                <NonEditableTextField label="Pourcentage (%)" value={zonePercentage} />
              </div>
            </Tooltip>
          </Grid>
        </Grid>

        <Grid item container xs={1} columnSpacing={1}>
          {/* To keep : next V. here comes delete and update icons, display structure is adapted ; functions to be defined*/}

          {/* <Grid item xs={6}>
            <SquareBadge
              onClick={handleEditUsage}
              icon={<IconPencil sx={{ color: customPalette.lightBlue2 }} />}
              backgroundColor={customPalette.lightGray7}
              cursor="pointer"
            />
          </Grid>
          <Grid item xs={6}>
            <SquareBadge
              onClick={handleDeleteUsage}
              icon={<IconTrash sx={{ color: customPalette.lightBlue2 }} />}
              backgroundColor={customPalette.lightGray7}
              cursor="pointer"
            />
          </Grid> */}
        </Grid>
      </Grid>
    </Paper>
  )
}
